// Event roles, shared by the event admin and root admin screens so both use the same names.
export const ROLE_OPTIONS = [
  { value: 'owner', label: 'Owner' },
  { value: 'event-admin', label: 'Event Admin' },
  { value: 'co-organizer', label: 'Co-organizer' },
  { value: 'activity-admin', label: 'Activity Admin' },
  { value: 'participant', label: 'Participant' },
];

export function roleLabel(role) {
  return ROLE_OPTIONS.find((r) => r.value === role)?.label || role;
}
